export default __webpack_public_path__ + "static/media/rude.ccdb4602.webp";